import React from 'react';

const Error = (): JSX.Element => <div className="error-component">Error</div>;

export default Error;
